import React from 'react';
import './style.css';
import logo from './selenne-logo.png';

const dominicanaServices = [
  'Business development planning for Dominican and international ventures',
  'Business support for Dominicans, foreign entrepreneurs, and international business owners',
  'Located in Santiago de los Caballeros, Dominican Republic',
  'Spanish-speaking business assistance for clients who need local communication support',
  'Paperwork preparation support, document organization, and live translation assistance',
  'DGII and DGA policy, procedure, and filing support for tax, customs, and compliance-readiness matters',
  'Brand positioning and market-readiness strategy',
  'Operational structure, intake workflows, and client systems',
  'Coordination support for formation, documentation, and compliance-readiness tasks',
  'Cross-border business organization for U.S. and Dominican initiatives',
  'Strategic planning for hospitality, retail, service, and specialty product brands',
];

function DominicanaPage() {
  return (
    <div className="site-shell dominicana-page">
      <header className="corporate-header">
        <a href="/" className="brand-block compact-brand" aria-label="Return to Selenne Strategies home">
          <img src={logo} alt="Selenne Strategies Logo" className="brand-logo" />
          <div>
            <p className="eyebrow">Selenne Strategies</p>
            <h1>Succursal Dominicana</h1>
          </div>
        </a>

        <nav className="main-nav" aria-label="Dominicana navigation">
          <a href="/">Home</a>
          <a href="#services">Services</a>
          <a href="#approach">Approach</a>
          <a href="#contact">Contact</a>
          <a href="/onboarding" className="nav-button">Start Assessment</a>
        </nav>
      </header>

      <main>
        <section className="hero-section dominicana-hero">
          <div className="hero-copy">
            <p className="section-kicker">Dominican Republic business presence</p>
            <h2>Selenne Strategies Succursal Dominicana</h2>
            <p>
              A Dominican sister company located in Santiago de los Caballeros, Dominican Republic, created to support business development,
              brand structure, document preparation, live translation, and operational planning for Dominicans, foreign entrepreneurs,
              and business owners building between U.S. and Dominican markets.
            </p>
            <div className="hero-actions">
              <a href="/onboarding" className="primary-button">Request a Consultation</a>
              <a href="mailto:info@selennestrategies.com" className="secondary-button">Email Us</a>
            </div>
          </div>

          <aside className="hero-panel light-panel">
            <span className="panel-label">Regional Focus</span>
            <h3>Local presence. International perspective.</h3>
            <p>
              Strategy, structure, Spanish-speaking support, and local coordination for entrepreneurs and companies operating with Dominican market interests.
            </p>
          </aside>
        </section>

        <section id="services" className="content-section services-section">
          <div className="section-heading">
            <p className="section-kicker">How we support clients</p>
            <h3>Dominicana Services</h3>
            <p>
              Support for entrepreneurs, founders, and organizations preparing to operate with stronger structure and professional presentation.
            </p>
          </div>

          <div className="checklist-grid">
            {dominicanaServices.map((service) => (
              <article className="check-card" key={service}>
                <span aria-hidden="true">✓</span>
                <p>{service}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="approach" className="split-section">
          <div>
            <p className="section-kicker">Our approach</p>
            <h3>Built for entrepreneurs who need structure before scale.</h3>
          </div>
          <div className="split-copy">
            <p>
			  Selenne Strategies Succursal Dominicana is designed to serve both Dominican and foreign business owners who need structure,
			  clarity, and professional assistance navigating business development in the Dominican Republic.
			</p>
			<p>
			  Our support includes paperwork organization, live translation assistance, Spanish-speaking client communication, and guidance
			  related to DGII and DGA policies, procedures, and filing-readiness needs.
			</p>
			<p>
			  This structure keeps the Dominican company connected to the Selenne Strategies brand while giving it a dedicated identity,
			  message, and service focus under the same domain.
			</p>
          </div>
        </section>

        <section id="contact" className="contact-section">
          <p className="section-kicker">Contact</p>
          <h3>Connect with Selenne Strategies Succursal Dominicana.</h3>
          <p>Use the inquiry form or email us to discuss your Dominican Republic business goals.</p>
          <div className="hero-actions center-actions">
            <a href="/onboarding" className="primary-button">Start Assessment</a>
            <a href="mailto:info@selennestrategies.com" className="secondary-button">info@selennestrategies.com</a>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <p>© {new Date().getFullYear()} Selenne Strategies Succursal Dominicana. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default DominicanaPage;
